export function getRateDisplayValue(value) {
    if (value === undefined || value === null) {
        return '';
    }

    if (value > 1 && value < 1.03) {
        return value.toFixed(3);
    } else {
        return value.toFixed(2);
    }
}

export function firstHandicapCondition(value) {
    if (value > 0) {
        return '+' + value;
    }

    return value;
}

export function secondHandicapCondition(value) {
    value = -value;

    if (value > 0) {
        return '+' + value;
    }

    return value;
}

export function addClass(element, className) {
    let n = 0;

    className = className.split(',');

    for (let i = 0; i < className.length; i++) {
        if ((' ' + element.className + ' ').indexOf(' ' + className[i] + ' ') == -1) {
            element.className += ' ' + className[i];
            n++;
        }
    }

    return n;
}

export function removeClass(element, className) {
    const remainingClasses = element.className.replace(new RegExp('\\b' + className + '\\b'), '');

    element.className = remainingClasses;
}



// WEBPACK FOOTER //
// ./js/rendering-commons/index.js